import type { Placement } from "@floating-ui/react";
import type { ComponentProps, ReactNode } from "react";

import type { ComponentWithChildren } from "@polyai/common/types/helpers";
import ConditionalWrapper from "@polyai/common/utils/conditionalWrapper";

import type { ColorName } from "styles/config/colors";
import Tooltip from "../Tooltip";

import * as Styled from "./HelpText.styled";

export interface HelpTextProps {
  help?: ReactNode;
  portal?: boolean;
  autoUpdateOptions?: ComponentProps<typeof Tooltip>["autoUpdateOptions"];
  inline?: boolean;
  backgroundColor?: ColorName;
  "data-test-id"?: string;
  className?: string;
  placement?: Placement;
}

const HelpText: ComponentWithChildren<HelpTextProps> = ({
  children,
  help,
  portal = false,
  autoUpdateOptions,
  inline,
  backgroundColor,
  "data-test-id": dataTestId = "help-text",
  className,
  placement = "top-start",
}) => {
  return (
    <ConditionalWrapper
      condition={!!help}
      wrapper={(children) => (
        <Styled.TooltipWrapper $inline={inline}>
          <Tooltip
            autoUpdateOptions={autoUpdateOptions}
            backgroundColor={backgroundColor}
            className={className}
            content={help}
            data-test-id={dataTestId}
            placement={placement}
            portal={portal}
          >
            <Styled.LabelWithHelp data-test-id="help-text-label" role="tooltip">
              {children}
            </Styled.LabelWithHelp>
          </Tooltip>
        </Styled.TooltipWrapper>
      )}
    >
      <span>{children}</span>
    </ConditionalWrapper>
  );
};

export default HelpText;
